





























































































import { Component, Prop, Watch, Mixins } from "vue-property-decorator";
import { FilteringSortingTableStore } from "@/mixins/tableWithFilteringAndSortingStore";
import { DataModules } from "@/store/modules/data";
import { IProduct } from "@/models/products";
import { UUID } from "@/data/enums";
import { IBrand } from "@/models/brands";

@Component
export default class ProductsSearchTable extends Mixins(
  FilteringSortingTableStore
) {
  //Props
  @Prop({ default: UUID.ORG })
  public brandId!: IBrand["id"];

  @Prop({ default: () => ({}) })
  public readonly manualFilters!: { [key: string]: string | number | boolean };

  @Prop({ default: "router-link" })
  public rowTag!: string;

  @Prop({ default: null })
  public onSelect!: Function;

  @Prop({ default: true })
  public isHoverable!: boolean;

  @Prop({ default: true })
  public showTableHead!: boolean;

  @Prop({
    default: () => (product: IProduct) => ({
      to: {
        name: "adminCatalogueProduct",
        params: { productId: product.id }
      }
    })
  })
  public rowProps!: (product: IProduct) => { [key: string]: string };

  @Prop({ default: () => () => ({}) })
  public rowEvents!: (product: IProduct) => { [key: string]: Function };

  // Override prop defaults from mixin

  @Prop({ default: "PT1" })
  public declare id: string;

  @Prop({ default: "$products_search" })
  public declare dataScope: string;

  @Prop({ default: true })
  public declare ignoreHistory: boolean;

  @Prop({ default: 5 })
  public declare limit: number;

  // Data
  public queryText = "";
  public searchWithDebounce = this.$_.debounce(this.debounceSearch, 250);
  public dataModule: DataModules = DataModules.CATALOGUE;

  // Lifecycle methods
  public created() {
    this.getData();
  }

  public beforeDestroy() {
    // Clear query when modal is closed
    const query = this.$_.clone(this.$route.query);
    if (this.$_.has(query, this.id)) {
      delete query[this.id];
      this.$router.replace({ query });
    }
  }

  @Watch("queryText")
  public onQueryTextChanged() {
    this.searchWithDebounce();
  }

  public get showRecentProducts() {
    return this.$_.isEmpty(this.queryText);
  }

  public get brandFilter() {
    return this.brandId !== UUID.ORG ? { brand_id: this.brandId } : {};
  }

  public get queryPayload() {
    return this.showRecentProducts
      ? {
          params: {
            order: "-created_at"
          }
        }
      : {
          params: {
            query: this.queryText
          }
        };
  }

  // Methods
  public debounceSearch() {
    return this.getData();
  }

  // overrides mixin method
  public getStoreParams(payload: any): Promise<any> {
    return this.$_.merge(
      payload,
      {
        storeModule: this.dataModule,
        ignoreStored: true,
        params: {
          with: "image",
          ...this.brandFilter,
          ...this.manualFilters,
          ...(this.queryText
            ? {
                "filter[name|like]": `%${this.queryText}%`
              }
            : {})
        }
      },
      this.queryPayload
    );
  }
}
